export default {
  sidebar: {
    switchSide: 'Seite wechseln',
    showSidebar: 'Seitenleiste zeigen',
    hideSidebar: 'Seitenleiste verbergen'
  }
}
